import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { signInFireabse } from '../Utils/firebase';
import  secureLocalStorage  from  "react-secure-storage";
import { socket } from 'src/socket';


//Services
import { authWithEmail, authWithGoogle, getMe, registerWithEmail, registerWithGoogle } from 'src/Api/services/authService';

//Login
export const sessionLogin = createAsyncThunk('session/login', async (userData, thunkAPI) => {
    return authWithEmail(userData)
        .then(tokenResp=>{
            secureLocalStorage.setItem("session", {
                token: tokenResp.data.token
            });
            return tokenResp.data;
        })
        .then( async(tokenData) =>{

            const userResp = await getMe();
            secureLocalStorage.setItem("session", {
                userId: userResp.data?.id,
                token: tokenData.token
            });

            return {
                token: tokenData.token,
                user: userResp.data,
                userType : tokenData?.userType,
                payment : userResp.data?.payment
            }

        })
        .catch(error=>{

            return thunkAPI.rejectWithValue(error.response.data.error);
        });
})

//Register
export const sessionRegister = createAsyncThunk('session/register', async (userData, thunkAPI) => {
    return registerWithEmail(userData)
        .then(tokenResp=>{
            secureLocalStorage.setItem("session", {
                token: tokenResp.data.token
            });
            return tokenResp.data;
        })
        .then( async(tokenData) =>{

            const userResp = await getMe();

            secureLocalStorage.setItem("session", {
                userId: userResp.data?.id,
                token: tokenData.token
            });

            return {
                token: tokenData.token,
                user: userResp.data,
                userType : tokenData?.userType,
                payment : userResp.data?.payment
            }

        })
        .catch(error=>{

            return thunkAPI.rejectWithValue(error.response.data.error);
        });
})


//Register with Google
export const sessionLoginGoogle = createAsyncThunk('session/loginGoogle', async (data, thunkAPI) => {


    const userCredential = await signInFireabse();
    const googleCredential = userCredential.credential;

    const request = userCredential.additionalUserInfo?.isNewUser ? registerWithGoogle : authWithGoogle;

    const payload = userCredential.additionalUserInfo?.isNewUser
        ? { googleData: userCredential.user, isCoach: true, googleCredential }
        : { googleData: userCredential.user, googleCredential };

    return request( payload )
        .then(tokenResp=>{
            secureLocalStorage.setItem("session", {
                token: tokenResp.data.token
            });
            return tokenResp.data;
        })
        .then( async(tokenData) =>{

            const userResp = await getMe();

            secureLocalStorage.setItem("session", {
                userId: userResp.data?.id,
                token: tokenData.token
            });

            return {
                token: tokenData.token,
                user: userResp.data,
                userType : tokenData?.userType,
                payment : userResp.data?.payment
            }

        })
        .catch(error=>{

            return thunkAPI.rejectWithValue(error.response.data.error);
        });
})


const initialState = {
    user: null,
    userType: null,
    token: null,
    isLogged: false,
    payment: null
}

export const sessionSlice = createSlice({
    name: 'session',
    initialState,
    reducers: {
        logout: (state) => {
            state = initialState;
            secureLocalStorage.clear();
            return state;
        },
        updateUser: (state, action) => {
            state.user = { ...state.user, ...action.payload.user };
            state.payment = state.user?.payment;
            return state;
        },
        updatePayment: (state, action) => {
            state.payment = action.payload.payment;
            state.paymentStatus = action.payload.paymentStatus;
            // Las pantallas leen el plan de user.payment: sin esto no se enteraban del cambio
            // (socket UPDATE_PAYMENT) hasta volver a cargar el usuario.
            if (state.user && action.payload.payment && typeof action.payload.payment === 'object') {
                state.user = { ...state.user, payment: action.payload.payment };
            }
            return state;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(sessionLogin.fulfilled, (state, action) => {

                //Socket
                socket.connect();

                state.user = action.payload.user;
                state.userType = action.payload.userType;
                state.token = action.payload.token;
                state.isLogged = true;
                state.paymentStatus = action.payload.paymentStatus;
                state.payment = action.payload.payment;
                return state;
            })
            .addCase(sessionLogin.rejected, (state) => {
                state = initialState;
                return state;
            })
            .addCase(sessionRegister.fulfilled, (state, action) => {

                //Socket
                socket.connect();

                state.user = action.payload.user;
                state.userType = action.payload.userType;
                state.token = action.payload.token;
                state.isLogged = true;
                state.paymentStatus = action.payload.paymentStatus;
                state.payment = action.payload.payment;

                return state;
            })
            .addCase(sessionLoginGoogle.fulfilled, (state, action) => {

                //Socket
                socket.connect();

                state.user = action.payload.user;
                state.userType = action.payload.userType;
                state.token = action.payload.token;
                state.isLogged = true;
                state.paymentStatus = action.payload.paymentStatus;
                state.payment = action.payload.payment;

                return state;
            })
            .addCase(sessionLoginGoogle.rejected, (state) => {
                state = initialState;
                return state;
            })
    }
})

// Action creators are generated for each case reducer function
export const { logout, updateUser, updatePayment } = sessionSlice.actions
export default sessionSlice.reducer
